module.exports = __webpack_public_path__ + "img/request-document.1f314c3f.svg";